/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
} from './EventName';

/**
 * 
 * @export
 * @interface SDKEventPersonIdentifiedV1
 */
export interface SDKEventPersonIdentifiedV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventPersonIdentifiedV1
     */
    event_name: EventName;
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventPersonIdentifiedV1
     */
    person_id: string;
}

/**
 * Check if a given object implements the SDKEventPersonIdentifiedV1 interface.
 */
export function instanceOfSDKEventPersonIdentifiedV1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;
    isInstance = isInstance && "person_id" in value;

    return isInstance;
}

export function SDKEventPersonIdentifiedV1FromJSON(json: any): SDKEventPersonIdentifiedV1 {
    return SDKEventPersonIdentifiedV1FromJSONTyped(json, false);
}

export function SDKEventPersonIdentifiedV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventPersonIdentifiedV1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
        'person_id': json['person_id'],
    };
}

export function SDKEventPersonIdentifiedV1ToJSON(value?: SDKEventPersonIdentifiedV1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_name': EventNameToJSON(value.event_name),
        'person_id': value.person_id,
    };
}

